/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * React's `createElement` function enhanced to deeply render Lit components in
 * the server. It is simply a passthrough of `React.createElement` in the
 * browser.
 */
export {createElement} from 'react';
